exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".status {\r\n  border: 1px solid;\r\n  border-radius: 4px;\r\n}\r\n\r\n.PendingConfirmation {\r\n  color: orange;\r\n  border-color: orange;\r\n}\r\n\r\n.Active {\r\n  color: green;\r\n  border-color: green;\r\n}\r\n\r\n.Inactive {\r\n  color: black;\r\n  border-color: black;\r\n}\r\n\r\n.Decline {\r\n  color: red;\r\n  border-color: red;\r\n}\r\n\r\n.New {\r\n  color: blue;\r\n  border-color: blue;\r\n}\r\n\r\nimg {\r\n  width: 70px;\r\n  margin-right: 0.5rem;\r\n  border-radius: 4px;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Biziclick/bizisystem/src/app/main/pages/system-hotel-requests/system-hotel-requests.component.css
// module id = ../../../../../src/app/main/pages/system-hotel-requests/system-hotel-requests.component.css
// module chunks = main